import { apiRequest } from '../../../api/client';
import type { TelegramAuthResponse } from '../../../api/types';

export interface TelegramAuthArgs {
  initData: string;
  // PARA-127, AC-7: метка источника привлечения из query-параметра URL Mini App.
  source?: string;
}

// PARA-105, AC-1: аутентификация по initData Telegram WebApp SDK.
export async function authenticateWithTelegram({
  initData,
  source,
}: TelegramAuthArgs): Promise<TelegramAuthResponse> {
  return apiRequest<TelegramAuthResponse>('/auth/telegram', {
    method: 'POST',
    body: { init_data: initData, ...(source ? { source } : {}) },
    skipAuth: true,
  });
}
